export default "__VITE_ASSET__DKv26tC2__"